import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

type TSetState = Dispatch<SetStateAction<any>>;

export class StoreEmitter {
  private events = new Map<string, Set<TSetState>>();
  private store = new Map<string, any>();

  on(key: string, setState: TSetState): void {
    if (this.events.has(key)) {
      this.events.get(key)!.add(setState);
    } else {
      this.events.set(key, new Set([setState]));
    }
  }

  off(key: string, setState: TSetState): void {
    const eventItem = this.events.get(key);

    if (eventItem?.has(setState)) {
      eventItem.delete(setState);

      if (!eventItem.size) {
        // 只清 events，不清 store
        this.events.delete(key);
      }
    }
  }

  emit(key: string, value: any): void {
    // events 没有此 key 也要执行 set：set 可能在异步中，执行时组件可能已经卸载并取消监听
    this.store.set(key, value);
    this.events.get(key)?.forEach((setState) => setState(value));
  }

  get(key: string): any {
    return this.store.get(key);
  }
}

// 这个默认值没有任何作用
const ContextStorage = createContext<StoreEmitter>(new StoreEmitter());

export default ContextStorage;
